.timeline {
    flex: 1;
    overflow: hidden;
    background: transparent;
    width: 100%;
}
